import React from "react";
interface DeleteDialogItemProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const DeleteDialogItem: React.FC<DeleteDialogItemProps> = ({
  children,
  className = "",
  onClick,
}) => {
  return (
    <div
      className={`min-h-(--item-height) hover:bg-list-hover transition-colors pr-1 flex items-center text-fg-regular ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
